// extracted by mini-css-extract-plugin
export default {"loading-overlay":"LoadingSpinner_loading-overlay__5yrMg","spinner":"LoadingSpinner_spinner__-vvAC","spin":"LoadingSpinner_spin__zN6XA"};